var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRankDiamondRibbonLightMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.149A10.12 10.12 0 005.872 19.277c0 1.25.238 2.442.655 3.514L19.515 9.804A9.704 9.704 0 0016 9.15z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.515 9.804L6.527 22.791c1.43 3.873 5.124 6.613 9.473 6.613a10.12 10.12 0 0010.127-10.128c0-4.348-2.74-8.042-6.612-9.472z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.825 9.685l4.35-2.204c.238-.06.357-.238.357-.477V2h-5.958v7.149c-1.132-.417-2.323-.596-3.574-.596s-2.443.238-3.575.596V2H6.468v5.004c0 .239.119.417.357.536l4.35 2.205a10.598 10.598 0 00-5.899 9.532C5.276 25.174 10.102 30 16 30c5.898 0 10.723-4.826 10.723-10.723 0-4.17-2.383-7.805-5.898-9.592zM16 28.213a8.924 8.924 0 01-8.936-8.936A8.924 8.924 0 0116 10.34a8.924 8.924 0 018.936 8.937A8.924 8.924 0 0116 28.213z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.297 13.677c2.92 0 5.064 2.383 5.064 5.6 0 3.336-2.085 5.66-5.064 5.66h-3.694v-11.26h3.694zm-1.49 9.234h1.55c1.668 0 2.8-1.49 2.8-3.635 0-2.144-1.132-3.633-2.8-3.633h-1.55v7.268z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.553c1.251 0 2.443.238 3.575.596V2h-7.15v7.149c1.133-.358 2.324-.596 3.575-.596z",
    fill: "#404040"
  })));
}

export default SvgIconRankDiamondRibbonLightMode;